import React from 'react';
import PropTypes from 'prop-types';

import {Field} from 'redux-form';

import FieldRadioGroup from '../../fields/fieldRadioGroup/FieldRadioGroup';

export default function ConstructedRadioGroupField({field}) {
  return (
    <Field
      name={field.code}
      label={`${field.name} ${field.required ? '*' : ''}`}
      choices={field.choices}
      required={field.required}
      component={FieldRadioGroup}
    />
  );
}



// WEBPACK FOOTER //
// ./components/constructedForm/fields/ConstructedRadioGroupField.js